(function () {

/* Image gallery (lightbox) functionality */ const $e2cb3d27daa5cda4$var$lightboxOverlay = document.querySelector('.lightbox-overlay');
const $e2cb3d27daa5cda4$var$lightboxImage = document.querySelector('.lightbox-overlay img');
const $e2cb3d27daa5cda4$var$lightboxCaption = document.querySelector('.lightbox-overlay .caption');
const $e2cb3d27daa5cda4$var$lightboxCloseBtn = document.querySelector('.lightbox-content .btn-close');
/* Open lightbox */ const $e2cb3d27daa5cda4$var$galleryImages = [
    ...document.querySelectorAll('.gallery-item img')
];
const $e2cb3d27daa5cda4$var$contentDiv = document.querySelector('.content');
const $e2cb3d27daa5cda4$var$lightboxNext = document.querySelector('.lightbox-content .btn-next');
const $e2cb3d27daa5cda4$var$lightboxPrev = document.querySelector('.lightbox-content .btn-prev');
function $e2cb3d27daa5cda4$var$showImageInLightbox(imageNode) {
    const captionElement = imageNode.parentElement.querySelector('figcaption');
    const captionText = captionElement ? captionElement.textContent : '';
    const imgIndex = $e2cb3d27daa5cda4$var$galleryImages.indexOf(imageNode);
    // show/hide next/prev buttons
    $e2cb3d27daa5cda4$var$lightboxPrev.style.visibility = imgIndex === 0 ? 'hidden' : 'visible';
    $e2cb3d27daa5cda4$var$lightboxNext.style.visibility = imgIndex === $e2cb3d27daa5cda4$var$galleryImages.length - 1 ? 'hidden' : 'visible';
    $e2cb3d27daa5cda4$var$lightboxImage.setAttribute('src', imageNode.src);
    $e2cb3d27daa5cda4$var$lightboxCaption.textContent = captionText;
}
$e2cb3d27daa5cda4$var$contentDiv.addEventListener('click', function(e) {
    if (e.target.matches('.gallery-item img')) {
        $e2cb3d27daa5cda4$var$lightboxOverlay.style.display = 'flex';
        $e2cb3d27daa5cda4$var$showImageInLightbox(e.target);
    }
});
/* Cycle through lightbox images */ function $e2cb3d27daa5cda4$var$showNextImageInLightbox() {
    const imgIndex = $e2cb3d27daa5cda4$var$galleryImages.findIndex((img)=>$e2cb3d27daa5cda4$var$lightboxImage.getAttribute('src').includes(img.getAttribute('src')));
    if (imgIndex === -1) return;
    if (imgIndex < $e2cb3d27daa5cda4$var$galleryImages.length - 1) $e2cb3d27daa5cda4$var$showImageInLightbox($e2cb3d27daa5cda4$var$galleryImages[imgIndex + 1]);
}
function $e2cb3d27daa5cda4$var$showPrevImageInLightbox() {
    const imgIndex = $e2cb3d27daa5cda4$var$galleryImages.findIndex((img)=>$e2cb3d27daa5cda4$var$lightboxImage.getAttribute('src').includes(img.getAttribute('src')));
    if (imgIndex === -1) return;
    if (imgIndex > 0) $e2cb3d27daa5cda4$var$showImageInLightbox($e2cb3d27daa5cda4$var$galleryImages[imgIndex - 1]);
}
$e2cb3d27daa5cda4$var$lightboxNext.addEventListener('click', $e2cb3d27daa5cda4$var$showNextImageInLightbox);
$e2cb3d27daa5cda4$var$lightboxPrev.addEventListener('click', $e2cb3d27daa5cda4$var$showPrevImageInLightbox);
/* Close lightbox */ function $e2cb3d27daa5cda4$var$closeLightbox(e) {
    $e2cb3d27daa5cda4$var$lightboxOverlay.style.display = 'none';
    $e2cb3d27daa5cda4$var$lightboxImage.removeAttribute('src');
    $e2cb3d27daa5cda4$var$lightboxCaption.textContent = '';
}
$e2cb3d27daa5cda4$var$lightboxCloseBtn.addEventListener('click', $e2cb3d27daa5cda4$var$closeLightbox);
// keyboard navigation
document.addEventListener('keydown', function(e) {
    const isLightboxVisible = $e2cb3d27daa5cda4$var$lightboxOverlay.style.display !== 'none';
    if (!isLightboxVisible) return;
    if (e.code === 'Escape') $e2cb3d27daa5cda4$var$closeLightbox();
    else if (e.code === 'ArrowRight') $e2cb3d27daa5cda4$var$showNextImageInLightbox();
    else if (e.code === 'ArrowLeft') $e2cb3d27daa5cda4$var$showPrevImageInLightbox();
});

})();
//# sourceMappingURL=vali-city.25807cd3.js.map
